import { render, staticRenderFns } from "./Episode.vue?vue&type=template&id=4e2b737e&scoped=true"
import script from "./Episode.vue?vue&type=script&lang=js"
export * from "./Episode.vue?vue&type=script&lang=js"
import style0 from "./Episode.vue?vue&type=style&index=0&id=4e2b737e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2b737e",
  null
  
)

export default component.exports